import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Wrapper: styled.div`
    background-color: ${defaultTheme.colors.white};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: ${defaultTheme.spacing(4)};
  `,
  Content: styled.div`
    display: flex;
    flex-direction: column;
    @media screen and (max-width: ${breakpoints.small}) {
      padding: ${defaultTheme.spacing(4)};
      max-width: ${breakpoints.small};
    }
  `,
  Header: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 88px;
    width: 100%;
    background-color: ${defaultTheme.colors.blueAccent}0F;
  `,
};
